import { Q2Game } from "../../net/proto/q2_game";
import Utility from "../../../../utility/utility";
import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
import UserDataManager from "../../../../manager/user_manager";
import ModelData, { IUserData } from "../../../public/model_data";
import GameUtil from "../../../../utility/game_util";
import ComponentBase from "../../../public/component/component_base";


const { ccclass, property, menu } = cc._decorator;

@ccclass
@menu('custom/q2/Q2TableResultItem')
export default class Q2TableResultItem extends ComponentBase {

    @property(cc.Node)
    nodeRoot: cc.Node = null

    @property(cc.Sprite)
    spriteNo: cc.Sprite = null

    @property(cc.Node)
    nodeHuTag: cc.Node = null

    @property(cc.Node)
    nodeGoldIcon: cc.Node = null

    @property(cc.Node)
    nodeChipIcon: cc.Node = null

    @property(cc.Sprite)
    spriteHead: cc.Sprite = null

    @property(cc.Label)
    labelName: cc.Label = null

    @property(cc.Label)
    labelScore: cc.Label = null

    @property(cc.Label)
    labelCoinBalance_win: cc.Label = null

    @property(cc.Label)
    labelCoinBalance_lose: cc.Label = null

    @property(SpriteFrameHolder)
    spriteHodlerNo: SpriteFrameHolder = null

    @property([cc.Node])
    nodeCupAnimList: cc.Node[] = []

    show(show: boolean, data?: Q2Game.GameSettle.ISeatInfo, no?: number, isMango?: boolean, huSeatId?: number, firstShow?: boolean){
        this.nodeRoot.active = !!show
        if(show){
            this.nodeChipIcon.active = !isMango
            this.nodeGoldIcon.active = !!isMango
            if(data.scoreBalance >= 0){
                this.labelScore.string = `+${data.scoreBalance}`
            }else{
                this.labelScore.string = `${data.scoreBalance}`
            }
            this.labelCoinBalance_win.node.active = data.balance > 0
            this.labelCoinBalance_lose.node.active = data.balance <= 0
            if(data.balance >= 0){                
                this.labelCoinBalance_win.string = '+' + GameUtil.currencyFormatting(data.balance)
            }else{
                this.labelCoinBalance_lose.string = GameUtil.currencyFormatting(data.balance)
            }
            this.nodeHuTag.active = huSeatId == data.seatId
            this.fillNoSprite(no)
            this.fillPlayerInfo(data.playerId)
            if(firstShow){
                this.showCup(false, 0)
                this.scheduleOnce(()=>{
                    this.showCup(data.playerId == ModelData.instance.roleData.id && data.balance > 0, no)
                }, 1) 
            }else{
                this.showCup(data.playerId == ModelData.instance.roleData.id && data.balance > 0, no)
            }                
        }
    }

    protected showCup(show: boolean, no: number){
        for (let index = 0; index < this.nodeCupAnimList.length; index++) {
            const element = this.nodeCupAnimList[index];
            element.active = show && no == index + 1
        }
    }

    protected fillPlayerInfo(uid: number){ 
        this.labelName.string = ''  
        this.spriteHead.spriteFrame = null     
        this.getUserData(uid, (data : IUserData) => { 
            this.labelName.string = Utility.filterPlayerName(data.name)
            this.spriteHead.spriteFrame = data.avatarSprite            
        });
    }

    protected fillNoSprite(no: number){
        this.spriteNo.spriteFrame = this.spriteHodlerNo.getSpriteFrameByKey(no.toString())
    }

}
